"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const tsyringe_1 = require("tsyringe");
const config_1 = require("./commons/config");
class App {
    /**
     * Initialize application dependencies
     *
     */
    static init(environment) {
        const defaultConfig = new config_1.DefaultConfig();
        tsyringe_1.container.register("config", {
            useValue: Object.assign(Object.assign({}, defaultConfig), environment),
        });
    }
}
exports.App = App;
//# sourceMappingURL=app.js.map